import { GridCol, GridContainer } from '@bob/library'
import Heading from '@websrc/App/Components/Heading/Heading'
import { spotWrapperProps } from '@websrc/App/Helpers/spotWrapperProps'
import { mapSwimlanes } from '@websrc/DataMappers/mapSpot'
import { styles } from 'leds'
import React from 'react'

import { DesktopSwimlanes } from './DesktopSwimlanes'
import { MobileSwimlanes } from './MobileSwimlanes'

export type SpotSwimlanesProps = {
  spot: ReturnType<typeof mapSwimlanes>
  isTopOfPage?: boolean
}

export const SpotSwimlanes: React.FC<SpotSwimlanesProps> = ({ spot, isTopOfPage }) => (
  <GridContainer data-testid={'caption'} {...spotWrapperProps(spot.caption)}>
    <GridCol
      className={styles({ textAlign: 'center', marginBottom: 40 })}
      desktop={10}
      desktopOffset={1}
      phone={12}
      tablet={8}
      tabletOffset={2}
    >
      <Heading
        description={spot.description}
        headline={spot.headline}
        label={spot.caption}
        level={isTopOfPage ? 1 : 2}
        noSpacing={true}
        size={'xl'}
        skipWidth={true}
        style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}
      />
    </GridCol>
    <GridCol>
      <DesktopSwimlanes {...spot} />
      <MobileSwimlanes {...spot} />
    </GridCol>
  </GridContainer>
)
